<div class="my-5">
    <!-- page-header with logout button -->
    <div class="flex items-center justify-between mb-4">
        <sm-page-header [breadcrumb]="breadcrumb" title="profile.title" description="profile.description"></sm-page-header>
        <p-button pButton pRipple size="small" class="ml-4" [label]="'profile.logout' | translate" (click)="logout()"></p-button>
    </div>

    <!-- Add the static image, full name, and email section here -->


    <!-- content -->
    <div class="content mb-2" *ngIf="!loading">
        <div class="flex items-center gap-6 mb-6 px-4">
            <div class="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center border border-gray-300">
                <i class="pi pi-user text-4xl text-gray-500"></i>
            </div>
            <div class="flex flex-col">
                <span class="text-xl font-semibold">{{ fullName }}</span>
                <span class="text-gray-500">{{ email }}</span>
            </div>
        </div>
        <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
        <div class="flex justify-end gap-2">
            <p-button [label]="'common.confirm' | translate" (click)="updateProfile()" />
            <p-button [label]="'profile.reset' | translate" severity="secondary" (click)="cancelEdit()" />
        </div>
    </div>

    <!-- Password Reset Section -->
    <div class="content w-full mb-6">
        <sm-form-builder [formObject]="passwordFormObject" class="w-full px-4"></sm-form-builder>
        <div class="flex justify-end mt-2">
            <p-button type="button" [label]="'profile.form.password.button' | translate" (click)="openPasswordDialog()" [disabled]="loading"></p-button>
        </div>
    </div>

    <p-tabs [(value)]="selectedTab" scrollable class="mt-4 bg-transparent">
      <p-tablist>
        <p-tab value="0">{{ 'settings.userInfo.tabs.roles' | translate }}</p-tab>
        <p-tab value="1">{{ 'settings.userInfo.tabs.acs' | translate }}</p-tab>
        <p-tab value="2">{{ 'settings.userInfo.tabs.coms' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-lg font-semibold">{{ 'settings.userInfo.tabs.roles' | translate }}</h3>
          </div>
          <sm-data-table-builder [dataTableObject]="rolesTableObject" [datas]="userRolesTableData" [loading]="loading"></sm-data-table-builder>
        </p-tabpanel>
        <p-tabpanel value="1">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-lg font-semibold">{{ 'settings.userInfo.tabs.acs' | translate }}</h3>
          </div>
          <sm-data-table-builder [dataTableObject]="acsTableObject" [datas]="userAcs" [loading]="loading"></sm-data-table-builder>
        </p-tabpanel>
        <p-tabpanel value="2">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-lg font-semibold">{{ 'settings.userInfo.tabs.coms' | translate }}</h3>
          </div>
          <sm-data-table-builder [dataTableObject]="comsTableObject" [datas]="userComs" [loading]="loading"></sm-data-table-builder>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <sm-spinner [loading]="loading"></sm-spinner>
    <sm-dialog #dialogComponent [dialog]="userDialog" [(visible)]="dialogVisible"></sm-dialog>
    <sm-dialog #dialogComponent [dialog]="passwordDialog" [(visible)]="passwordDialogVisible"></sm-dialog>
</div>

